import React from "react";


const PageNotFound = () => {
    return (
        <>Page Not Found </>
    )
};

export default PageNotFound;